import React from 'react';
import { InstagramIcon, FacebookIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#131A2B] text-white py-16 pb-[5px]" data-id="element-81">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-82">
        <div className="flex flex-col md:flex-row justify-between items-start gap-12 md:gap-8" data-id="element-83">
          {/* Column 1 - Logo & Social */}
          <div className="flex flex-col items-center md:items-start" data-id="element-84">
            {/* Logo */}
            <div className="mb-6" data-id="element-85">
              <img src="https://cdn.magicpatterns.com/uploads/wmkTZDbpPzqucnUGnbd3Ps/beclinical.svg.png" alt="Be Clinical" className="h-20 w-auto" data-id="element-86" />
            </div>

            {/* Social Icons */}
            <div className="flex gap-3" data-id="element-87">
              <a href="#" className="text-white hover:text-[#FF1493] transition-colors" aria-label="Instagram" data-id="element-88">
                <InstagramIcon size={20} data-id="element-89" />
              </a>
              <a href="#" className="text-white hover:text-[#FF1493] transition-colors" aria-label="Facebook" data-id="element-90">
                <FacebookIcon size={20} data-id="element-91" />
              </a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div className="flex flex-col md:items-start gap-4 items-start justify-start" data-id="element-92">
            <a href="#about" className="font-heading text-sm uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors" data-id="element-93">
              About Us
            </a>
            <a href="#treatments" className="font-heading text-sm uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors" data-id="element-94">
              Treatments
            </a>
            <a href="#blog" className="font-heading text-sm uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors" data-id="element-95">
              Blog
            </a>
          </div>

          {/* Column 3 - Contact Info */}
          <div className="flex flex-col md:items-start gap-6 items-start justify-start" data-id="element-96">
            <div data-id="element-97">
              <p className="font-heading text-xs uppercase tracking-widest text-white font-bold mb-2" data-id="element-98">
                Contact Number:
              </p>
              <a href="tel:9252151160" className="font-body text-sm text-gray-300 hover:text-[#FF1493] transition-colors" data-id="element-99">
                925.215.1160
              </a>
            </div>

            <div data-id="element-100">
              <p className="font-heading text-xs uppercase tracking-widest text-white font-bold mb-2" data-id="element-101">
                Address:
              </p>
              <p className="font-body text-xs uppercase text-gray-400 leading-relaxed" data-id="element-102">
                3130 CROW CANYON PL SUITE 180
                <br data-id="element-103" />
                SAN RAMON, CA 94583
              </p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-6 border-t border-white/10 text-center" data-id="element-104">
          <p className="italic text-xs text-gray-600 font-[Poppins,_sans-serif]" data-id="element-105">
            Copyright & Disclaimer © 2026 Beclinical. All Rights Reserved.
            Designed by thejaeefunnels
          </p>
        </div>
      </div>
    </footer>;
}